'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/IconSvg/index.js');
var index$1 = require('../../atoms/Button/index.js');
var ReactDOM = require('react-dom');
var tasksDone = require('../../../images/tasks-done.png.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

var ImageModal = function ImageModal(_ref) {
  var onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      hideModal = _ref.hideModal,
      className = _ref.className,
      imageRoute = _ref.imageRoute,
      localSource = _ref.localSource,
      container = _ref.container,
      title = _ref.title,
      subtitle = _ref.subtitle,
      cancelText = _ref.cancelText,
      confirmText = _ref.confirmText,
      showCancel = _ref.showCancel;

  var handleSelect = function handleSelect(e) {
    hideModal(e);
    onConfirm();
  };

  var handleKeyDown = function handleKeyDown(e) {
    var isEnter = e.keyCode === 13;
    var isEsc = e.keyCode === 27;

    if (isEnter) {
      e.preventDefault();
      handleSelect();
    }

    if (isEsc) {
      hideModal(e);
    }
  };

  React.useEffect(function () {
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown, false);
    return function () {
      document.body.removeAttribute('style');
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, []);
  var modalContent = React__default['default'].createRef();

  var handleOverlayClose = function handleOverlayClose(e) {
    var currentModalContent = modalContent === null || modalContent === void 0 ? void 0 : modalContent.current;

    if (currentModalContent && !currentModalContent.contains(e.target)) {
      e.preventDefault();
      hideModal(e);
    }
  };

  var hide = function hide(e) {
    if (e) {
      e.stopPropagation();
    }

    hideModal(e);
  };

  var handleCancel = function handleCancel(e) {
    hideModal(e);
    onCancel();
  };

  return ReactDOM__default['default'].createPortal( /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-org-modal-overlay ".concat(className),
    onClick: handleOverlayClose,
    onKeyDown: handleKeyDown,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-org-modal with-image",
    ref: modalContent
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    onClick: hide,
    className: "ds-org-modal-close"
  }, /*#__PURE__*/React__default['default'].createElement(index, {
    className: "ds-org-modal-close-icon",
    icon: "cross",
    localSource: localSource
  })), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("img", {
    className: "ds-org-modal-image",
    alt: "default blank slate",
    src: imageRoute
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-org-modal-header"
  }, title), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-org-modal-text"
  }, subtitle), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-org-modal-footer"
  }, showCancel && /*#__PURE__*/React__default['default'].createElement(index$1, {
    onSelect: handleCancel,
    className: "ds-org-modal-footer-button",
    secondary: true
  }, cancelText), /*#__PURE__*/React__default['default'].createElement(index$1, {
    onSelect: handleSelect,
    className: "ds-org-modal-footer-button"
  }, confirmText))))) || [], container ? document.querySelector(container) : document.body);
};

ImageModal.propTypes = {
  onCancel: PropTypes__default['default'].func,
  onConfirm: PropTypes__default['default'].func.isRequired,
  hideModal: PropTypes__default['default'].func.isRequired,
  className: PropTypes__default['default'].string,
  imageRoute: PropTypes__default['default'].string,
  container: PropTypes__default['default'].string,
  localSource: PropTypes__default['default'].bool,
  title: PropTypes__default['default'].string,
  subtitle: PropTypes__default['default'].node,
  cancelText: PropTypes__default['default'].string,
  confirmText: PropTypes__default['default'].string,
  showCancel: PropTypes__default['default'].bool
};
ImageModal.defaultProps = {
  onCancel: function onCancel() {},
  className: '',
  imageRoute: tasksDone,
  container: '',
  localSource: false,
  subtitle: '',
  title: '',
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  showCancel: true
};

module.exports = ImageModal;
